export const TelegramIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7769_126905)">
        <path
          d="M12 22.8184C17.5228 22.8184 22 18.3412 22 12.8184C22 7.29551 17.5228 2.81836 12 2.81836C6.47715 2.81836 2 7.29551 2 12.8184C2 18.3412 6.47715 22.8184 12 22.8184Z"
          fill="url(#paint0_linear_7769_126905)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.52661 12.7123C9.4418 11.4422 11.3857 10.6049 12.3584 10.2003C15.1355 9.04526 15.7125 8.8446 16.0886 8.83796C16.1714 8.83651 16.3563 8.85702 16.4761 8.95425C16.6539 9.09847 16.6549 9.41151 16.6352 9.6187C16.4847 11.2 15.8335 15.0372 15.5022 16.8082C15.362 17.5576 15.086 17.8089 14.8188 17.8334C14.2381 17.8869 13.7971 17.4496 13.2347 17.081C12.3545 16.504 11.8573 16.1449 11.003 15.5819C10.0157 14.9313 10.6557 14.5737 11.2184 13.9893C11.3656 13.8364 13.9243 11.5091 13.9738 11.2979C13.98 11.2715 13.9857 11.1731 13.9273 11.1211C13.8688 11.0692 13.7825 11.0869 13.7202 11.101C13.632 11.1211 12.2259 12.0504 9.50219 13.889C9.10309 14.1631 8.74161 14.2966 8.41774 14.2896C8.06067 14.2819 7.37387 14.0877 6.86329 13.9217C6.23704 13.7182 5.7393 13.6105 5.78266 13.2648C5.80524 13.0847 6.05321 12.9006 6.52661 12.7123Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_7769_126905"
          x1="12"
          y1="2.81836"
          x2="12"
          y2="22.6621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2AABEE" />
          <stop offset="1" stopColor="#229ED9" />
        </linearGradient>
        <clipPath id="clip0_7769_126905">
          <rect width="20" height="20" fill="white" transform="translate(2 2.81836)" />
        </clipPath>
      </defs>
    </svg>
  );
};
